import { render, staticRenderFns } from "./GameListRoute.vue?vue&type=template&id=5f3635c4&scoped=true&"
import script from "./GameListRoute.vue?vue&type=script&lang=js&"
export * from "./GameListRoute.vue?vue&type=script&lang=js&"
import style0 from "./GameListRoute.vue?vue&type=style&index=0&lang=css&"
import style1 from "./GameListRoute.vue?vue&type=style&index=1&id=5f3635c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3635c4",
  null
  
)

export default component.exports